<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sYeMTL/tc-custom/9780802192905.jpg?1708658264634" alt="This image is the cover for the book Singing at the Gates"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Singing at the Gates
      </h1>
      <p class="bookDescription body article font2">
        <b>“This fiery retrospective collection” of poetry by the acclaimed Chicano-American author of <i>A Place to Stand</i> is “warm and furious…righteous and prayerful” (<i>Booklist</i>).</b><br/><br/>Award-winning writer Jimmy Santiago Baca is lauded for his talent in weaving personal and political threads to create a pertinent and poignant narrative. He addresses universal issues with passion, grace, and vivid sensory detail.<br/><br/><i>Singing at the Gates</i> is a collection of Baca’s work stretching across four decades—poems that revitalize the national dialogue: raging against war and imprisonment, celebrating family and the bonds of friendship, heightening appreciation for and consciousness of the environment. A career-spanning selection, it includes poems drawn from Baca’s first chapbook, letters he wrote from prison to a woman named Mariposa, and recent meditations on the significance of breaking through oppression. <br/><br/><b>“A poet whose voice, brutal and tender, is unique in America.”—<i>The Nation</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jimmy Santiago Baca
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove/Atlantic Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?619c07b4